document.addEventListener("DOMContentLoaded", function () {
    const togglers = document.querySelectorAll("#uniqueList .caret");

    togglers.forEach(toggler => {
        toggler.addEventListener("click", function () {
            const nestedList = this.nextElementSibling; // Select the next UL

            if (nestedList) {
                nestedList.classList.toggle("active"); // Add/remove active class
                this.classList.toggle("caret-down"); // Toggle caret direction

                // Smooth Expand/Collapse
                if (nestedList.style.display === "block") {
                    nestedList.style.display = "none"; // Collapse
                } else {
                    nestedList.style.display = "block"; // Expand
                }
            }
        });
    });
});